<div class="top-menu bg-top-menu color-light font-14">
    <div class="top-menu__inner" *ngIf="subtitles.downloaded && menu.downloaded">
        <div class="top-menu__dropdown-button"
             [style.cursor]="parameters.offline ? 'default' : 'pointer'"
             (click)="parameters.offline ? false : showDropdownMenuFunction()">
            <img class="top-menu__dropdown-icon"
                 ngSrc="/assets/img/top_menu/dropdown_menu.svg"
                 alt="" width="32" height="32" />
            <div class="top-menu__dropdown-text">{{subtitle(388)}}</div>
        </div>

        <div class="top-menu__logo cursor-pointer"
             *ngIf="parameters.urlCompany === 'tech'"
             (click)="homeScreen()"
             [class]="{'top-menu__logo--hide': parameters.modules.length > 1}">
            <img *ngIf="subtitles.language === 'pl'"
                 src="/assets/img/top_menu/logo_tech_vector_2.svg"
                 class="top-menu__logo-tech" width="90" height="60" alt="" />
            <img *ngIf="subtitles.language !== 'pl'"
                 src="/assets/img/top_menu/logo_tech_vector_2_en.svg"
                 class="top-menu__logo-tech" width="90" height="60" alt="" />
        </div>

        <div class="top-menu__logo bg-logo cursor-pointer"
            *ngIf="parameters.urlCompany === 'klimor'"
            (click)="homeScreen()"
            [class]="{'top-menu__logo--hide': parameters.modules.length > 1}">
            <img ngSrc="/assets/img/logo/menuLogo.svg"
                 class="top-menu__logo-tech" width="90" height="60" alt="" />
        </div>

        <div class="img-roth top-menu__logo cursor-pointer"
             *ngIf="parameters.urlCompany == 'roth'"
             (click)="homeScreen()"
             [class]="{'top-menu__logo--hide': parameters.modules.length > 1}">
            <img class="top-menu__logo-tech"
                 ngSrc="/assets/img/roth_white.svg"
                 width="113" height="60" alt="" />
        </div>

        <div class="top-menu__buttons-wrapper bg-top-menu"
             [class]="{'top-menu__buttons-wrapper--show': !menu.showDropdownMenu}"
             [style.max-height.px]="windowHeight + 48">

            <div class="top-menu__button bg-top-menu__button border-top-home-button"
                 [class]="{'top-menu__button--show': menu.showDropdownMenu,
                 'bg-top-menu__button--selected': uiRouterGlobals.current.name === 'home'}"
                 (click)="homeScreen()">

                <img class="top-menu__icon"
                     ngSrc="/assets/img/top_menu/home.svg"
                     width="32" height="32" alt="" />
                <div class="top-menu__text">{{subtitle(1782)}}</div>
            </div>

            <div class="top-menu__button bg-top-menu__button"
                 [class]="{'top-menu__button--show': menu.showDropdownMenu,
                    'bg-top-menu__button--selected': uiRouterGlobals.current.name === 'zones_settings'}"
                 *ngIf="hasZones()"
                 (click)="zonesSettingsScreen()">
                <img class="top-menu__icon"
                     ngSrc="/assets/img/top_menu/zones.svg"
                     width="32" height="32" alt="" />
                <div class="top-menu__text">{{subtitle(1752)}}</div>
            </div>

            <div class="menu__parent color-light"
                 [class]="{'menu__parent--hide': !menu.showDropdownMenu,
                     'cursor-pointer': parameters.selectedModule.moduleStatus && parameters.selectedModule.controllerStatus}"
                 *ngFor="let val of getMainMenuAsArray()">

                <div class="menu__parent-item"
                     [class]="{'menu__parent-item--selected':
                        menu.checkSelectedMenu(val[1][0].menuType).toString() === uiRouterGlobals.current.name}"
                     (click)="menu.goToMenu(val[1], parameters.selectedModule)">
                    <img class="menu__parent-img"
                         src="{{setIconUrl(val[1][0].menuType)}}"
                         width="37" height="37" alt="" />
                    <div class="menu__parent-name">{{subtitle(val[1][0].txtId)}}</div>
                </div>
            </div>

            <div class="top-menu__button bg-top-menu__button"
                 [class]="{'top-menu__button--show': menu.showDropdownMenu,
                    'bg-top-menu__button--selected': uiRouterGlobals.current.name === 'alarm_history'}"
                 *ngIf="parameters.selectedModuleType !== 'zones_controller'
                   && parameters.hasModules()"
                 (click)="alarmHistoryScreen()">
                <img class="top-menu__icon"
                     ngSrc="/assets/img/top_menu/alarm_history.svg"
                     width="32" height="32" alt="" />
                <div class="top-menu__text">{{subtitle(1170)}}</div>
            </div>

            <div class="top-menu__button bg-top-menu__button"
                 [class]="{'top-menu__button--show': menu.showDropdownMenu,
                    'bg-top-menu__button--selected': uiRouterGlobals.current.name === 'statistics'}"
                 *ngIf="parameters.hasModules()"
                 (click)="statisticsScreen()">
                <img class="top-menu__icon"
                     ngSrc="/assets/img/top_menu/statistics.svg"
                     width="32" height="32" alt="" />
                <div class="top-menu__text">{{subtitle(1089)}}</div>
            </div>

            <div class="top-menu__button bg-top-menu__button"
                 [class]="{'top-menu__button--show': menu.showDropdownMenu,
                    'bg-top-menu__button--selected': isSettingsSelected()}"
                 (click)="settingsScreen()">
                <img class="top-menu__icon"
                     ngSrc="/assets/img/top_menu/settings.svg"
                     width="32" height="32" alt="" />
                <div class="top-menu__text">{{subtitle(845)}}</div>
            </div>

            <div class="top-menu__button bg-top-menu__button"
                 [class]="{'top-menu__button--show': menu.showDropdownMenu}"
                 (click)="authentication.logout()">
                <img class="top-menu__icon"
                     ngSrc="/assets/img/top_menu/logout.svg"
                     width="32" height="32" alt="" />
                <div class="top-menu__text">{{subtitle(1091)}}</div>
            </div>
        </div>

        <div class="module-selection" *ngIf="parameters.modules.length > 1">
            <div class="module-selection__inner bg-top-menu__button border-module-selection"
                 (click)="parameters.offline ? false : showModuleListFunction()"
                 [class]="{ 'cursor-pointer': !parameters.offline,
                    'module-selection__inner--disable-hover': !parameters.offline }">
                <div class="module-selection__name font-16">
                    <div class="module-selection__name-inner">
                        {{ (parameters.modules[parameters.selectedModuleIndex].id + 1)
                        + '. ' + parameters.modules[parameters.selectedModuleIndex].name }}
                    </div>
                </div>
                <img class="module-selection__icon"
                     ngSrc="/assets/img/top_menu/arrow_down.svg"
                     width="16" height="16" alt="" />
            </div>

            <div class="module-selection__option-name cursor-default">
                 {{subtitle(1241)}}
            </div>

            <div class="module-selection-list-in-menu" *ngIf="showModulesList">
                <div class="module-selection-list bg-top-menu border-module-selection font-16 cursor-pointer"
                    data-testid="modules-list-desktop">
                    <div *ngFor="let element of parameters.modules; let i = index"
                         class="module-selection-list__element bg-top-menu__button border-bottom-module-selection"
                         (click)="selectModule(element.id, element.style)"
                         title="{{ element.version }}">
                        <div class="module-selection-list__element-inner">
                             {{ (element.id + 1) + '. ' + element.name }}
                        </div>
                        <img class="module-selection-list__icon"
                             ngSrc="/assets/img/top_menu/selected{{
                                i === parameters.selectedModuleIndex ? '' : '_not'
                             }}.svg"
                             width="16" height="16" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="module-selection-list-outside-menu"
     *ngIf="showModulesList"> <!-- fix for z-index issue in IE11 -->
    <div class="module-selection-list bg-top-menu border-module-selection font-16 color-light cursor-pointer"
        data-testid="modules-list-mobile">
        <div *ngFor="let element of parameters.modules; let i = index"
             class="module-selection-list__element bg-top-menu__button border-bottom-module-selection"
             (click)="selectModule(element.id, element.style)"
             title="{{ element.version }}">
            <div class="module-selection-list__element-inner">
                 {{ (element.id + 1) + '. ' + element.name}}
            </div>
            <img class="module-selection-list__icon"
                ngSrc="/assets/img/top_menu/selected{{
                    i === parameters.selectedModuleIndex ? '' : '_not'
                }}.svg"
                width="20" height="20" alt="" />
        </div>
    </div>
</div>

@if (showModulesList) {
    <div class="module-selection-cover-screen" (click)="clickOutside()"></div>
}
